// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '@/assets/css/animate.css'
import '@/assets/css/global.css'
import store from '@/store/'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import iView from 'iview'
import i18n from "./language"
import 'babel-polyfill'
import 'iview/dist/styles/iview.css'
import PlugIn from '@/lib/utils/'
import Vant from 'vant';
import 'vant/lib/index.css';
// import Print from 'vue-print-nb'
import 'url-search-params-polyfill'
import { validatenull } from '@/lib/utils/index'

// Vue.use(Print) // 注册
Vue.prototype.validatenull = validatenull;
Vue.use(Vant)
Vue.prototype.copyright = '（中国田径协会版权所有,未经允许不得转载。）'
Vue.use(PlugIn)
Vue.use(iView)
Vue.prototype.$axios = axios
Vue.prototype.$qs = Qs
Vue.config.productionTip = false
Vue.prototype.$setgoindex = function (indexChecked, gameTime) {
  let games = this.$store.state.grade.setGames
  let titileENG = games.titileENG ? games.titileENG : 0

  this.$router.push({ path: `/games?&titileENG=${titileENG}&id=${games.gameID}&title=${games.TieleStr}&visible=${games.visible}&indexChecked=${indexChecked}&time=${gameTime || ''}` })
}
Vue.prototype.sexSortName = function (sex) {
  let str = sex

  if (sex == '男子组') {
    str = this.$t('manGroup')
  } else if (sex == '女子组') {
    str = this.$t('womanGroup')
  } else if (sex == '混合组') {
    str = this.$t('commixtureGroup')
  } else if (sex == '成年男子组') {
    str = this.$t('adultManGroup')
  } else if (sex == '成年女子组') {
    str = this.$t('adultWomanGroup')
  } else if (sex == '成年混合组') {
    str = this.$t('adultCommixtureGroup')
  } else if (sex == '青年男子组') {
    str = this.$t('youthManGroup')
  } else if (sex == '青年女子组') {
    str = this.$t('youthWomanGroup')
  } else if (sex == '青年混合组') {
    str = this.$t('youthCommixtureGroup')
  } else if (sex == '少年男子组') {
    str = this.$t('juvenileManGroup')
  } else if (sex == '少年女子组') {
    str = this.$t('juvenileWomanGroup')
  } else if (sex == '少年混合组') {
    str = this.$t('juvenileCommixtureGroup')
  }
  return str
}
Vue.prototype.eventStr = function (events) {
  let str = events
  if (events == '链球') {
    str = this.$t('weightThrow')
  } else if (events == '铅球') {
    str = this.$t('shotPut')
  } else if (events == '铁饼') {
    str = this.$t('discus')
  } else if (events == '跳高') {
    str = this.$t('highJump')
  } else if (events == '跳远') {
    str = this.$t('longJump')
  } else if (events == '标枪') {
    str = this.$t('javelin')
  } else if (events == '撑竿跳高') {
    str = this.$t('poleVault')
  } else if (events == '4x100米接力') {
    str = this.$t('relay4_100')
  } else if (events == '4x200米接力') {
    str = this.$t('relay4_200')
  } else if (events == '4x400米接力') {
    str = this.$t('relay4_400')
  } else if (events == '4x100米混合接力') {
    str = this.$t('Mixed4_100m')
  } else if (events == '七项全能') {
    str = this.$t('all_round7')
  } else if (events == '三项全能') {
    str = this.$t('all_round3')
  } else if (events == '五项全能') {
    str = this.$t('all_round5')
  } else if (events == '十项全能') {
    str = this.$t('all_round10')
  } else if (events == '三级跳远') {
    str = this.$t('theTripleJump')
  } else if (events == '半程马拉松') {
    str = this.$t('halfwayMarathon')
  } else if (events == '马拉松') {
    str = this.$t('marathon')
  } else if (events == '10000米') {
    str = this.$t('meters10000')
  } else if (events == '1000米') {
    str = this.$t('meters1000')
  } else if (events == '100米') {
    str = this.$t('meters100')
  } else if (events == '500米') {
    str = this.$t('meters500')
  } else if (events == '1500米') {
    str = this.$t('meters1500')
  } else if (events == '3000米') {
    str = this.$t('meters3000')
  } else if (events == '2000米') {
    str = this.$t('meters2000')
  } else if (events == '200米') {
    str = this.$t('meters200')
  } else if (events == '300米') {
    str = this.$t('meters300')
  } else if (events == '400米') {
    str = this.$t('meters400')
  } else if (events == '5000米') {
    str = this.$t('meters5000')
  } else if (events == '55米') {
    str = this.$t('meters55')
  } else if (events == '600米') {
    str = this.$t('meters600')
  } else if (events == '60米') {
    str = this.$t('meters60')
  } else if (events == '800米') {
    str = this.$t('meters800')
  } else if (events == '10000米竞走') {
    str = this.$t('meters10000track')
  } else if (events == '20000米竞走') {
    str = this.$t('meters2000track')
  } else if (events == '3000米竞走') {
    str = this.$t('meters3000track')
  } else if (events == '5000米竞走') {
    str = this.$t('meters5000track')
  } else if (events == '100公里') {
    str = this.$t('kilometre100')
  } else if (events == '15公里') {
    str = this.$t('kilometre15')
  } else if (events == '10公里') {
    str = this.$t('kilometre10')
  } else if (events == '20公里') {
    str = this.$t('kilometre20')
  } else if (events == '25公里') {
    str = this.$t('kilometre25')
  } else if (events == '30公里') {
    str = this.$t('kilometre30')
  } else if (events == '100米栏') {
    str = this.$t('meters100hurdle')
  } else if (events == '200米栏') {
    str = this.$t('meters200hurdle')
  } else if (events == '110米栏') {
    str = this.$t('meters10hurdle')
  } else if (events == '400米栏') {
    str = this.$t('meters400hurdle')
  } else if (events == '55米栏') {
    str = this.$t('meters55hurdle')
  } else if (events == '60米栏') {
    str = this.$t('meters60hurdle')
  } else if (events == '50米栏') {
    str = this.$t('meters50hurdle')
  } else if (events == '10公里竞走') {
    str = this.$t('kilometre10track')
  } else if (events == '30公里竞走') {
    str = this.$t('kilometre30track')
  } else if (events == '35公里竞走') {
    str = this.$t('kilometre35track')
  } else if (events == '3公里竞走') {
    str = this.$t('kilometre3track')
  } else if (events == '50公里竞走') {
    str = this.$t('kilometre50track')
  } else if (events == '5公里竞走') {
    str = this.$t('kilometre5track')
  } else if (events == '10英里') {
    str = this.$t('mile10')
  } else if (events == '1英里') {
    str = this.$t('mile1')
  } else if (events == '2英里') {
    str = this.$t('mile2')
  } else if (events == '2000米障碍') {
    str = this.$t('meters2000barrier')
  } else if (events == '3000米障碍') {
    str = this.$t('meters300barrier')
  } else if (events == '掷棒') {
    str = this.$t('ClubThrow')
  } else {
    str = events
  }
  return str
}

Vue.prototype.matcStr = function (matc) {
  let str = matc
  if (matc == '及格赛') {
    str = this.$t('qualifyingTrial')
  } else if (matc == '预赛') {
    str = this.$t('preliminaryHeats')
  } else if (matc == '决赛') {
    str = this.$t('final')
  } else if (matc == '复赛') {
    str = this.$t('intermediaryHeat')
  } else if (matc == '半决赛') {
    str = this.$t('semifinal')
  } else if (matc == '次赛') {
    str = this.$t('roundTrial')
  }
  return str
}
Vue.prototype.$loadings = (str)=> {
  let title = str ? str : '数据提交中，请稍后...';
  Vue.prototype.$Spin.show({
    render: (h) => {
        return h('div', [
            h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                    type: 'ios-loading',
                    size: 18
                }
            }),
            h('div',{
                'class': 'loadingColor',
            },title)
        ])
    }
  });
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js